// The Program legend's "(watch in advance)" (Seán, 2026-10-29): only while the days open are
// online ones (the online Masterclass watches the full-length talks first); an open on-site day
// (in person, or online and on site) drops it. Across every program table on the page: the
// Masterclass page has several, with one legend.
import {computed, onUnmounted, reactive, watchEffect} from "vue";

const openModesByTable = reactive(new Map());
let nextTableId = 0;

// getOpenModes: the modes ("Online only", "On-site only", …) of the table's open days' items
export default function useOpenDayModes(getOpenModes) {
  const tableId = nextTableId++;
  watchEffect(() => openModesByTable.set(tableId, getOpenModes()));
  onUnmounted(() => openModesByTable.delete(tableId));
  return computed(() => {
    const modes = [...openModesByTable.values()].flat();
    if (modes.some((mode) => /on-site/i.test(mode))) return false;
    return modes.some((mode) => /online/i.test(mode));
  });
}
